<template>
  <main>
    <app-legend :value="isActive && layerName" :layerName="layerName"
      style="position: absolute; bottom: 15px; margin-left: 15px; z-index: 1;"
    ></app-legend>

    <v-navigation-drawer ref="nav" app disable-resize-watcher hide-overlay mobile-break-point="0" :value="isActive" width="500">
      <v-container fluid class="pa-0">
        <v-toolbar flat>
          <v-toolbar-title>{{$t('icus.title')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$store.dispatch('disableControl')" :disabled="isLoading">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-container>
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                :items="mesesDatos"
                v-model="mes"
                item-text="translate"
                style="text-transform: capitalize;"
                prepend-inner-icon="calendar_today"
                append-icon="keyboard_arrow_down"
                return-object
                persistent-hint
                :hint="$t('icus.select.month')"
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="stats"
                v-model="stat"
                item-text="translate"
                style="text-transform: capitalize;"
                prepend-inner-icon="bar_chart"
                append-icon="keyboard_arrow_down"
                return-object
                persistent-hint
                :hint="$t('icus.select.stat')"
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="zones"
                v-model="zone"
                style="text-transform: capitalize;"
                prepend-inner-icon="select_all"
                append-icon="keyboard_arrow_down"
                return-object
                persistent-hint
                :hint="$t('icus.select.zone')"
              ></v-select>
            </v-flex>
          </v-layout>

          <h2 class="pt-4">{{$t('icus.datos_para_la_zona')}} +{{zone}}º</h2>
          <h4 class="green--text">{{date}}</h4>
          <v-layout row wrap v-if="zone">

            <v-flex xs6 class="pa-1">
              <v-card height="150" class="text-xs-center">
                <v-card-text>
                  <h4 class="mb-2">{{$t('icus.superficie')}} (Ha)</h4>
                  <p>{{$t('icus.zone')}}: {{results.zone.superficie
                    .toFixed(0)}}</p>
                  <p>{{$t('icus.total')}}: {{results.total.superficie.toFixed(0)}}</p>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs6 class="pa-1">
              <v-card height="150" class="text-xs-center">
                <v-card-text>
                  <h4 class="mb-2">{{$t('icus.poblacion')}} (habs.)</h4>
                  <p>{{$t('icus.zone')}}: {{results.zone.poblacion}}</p>
                  <p>{{$t('icus.total')}} {{results.total.poblacion}}</p>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs6 class="pa-1">
              <v-card height="150" class="text-xs-center">
                <v-card-text>
                  <h4 class="mb-2">{{$t('icus.refrigeracion')}} (MWh)</h4>
                  <p>{{$t('icus.zone')}}: {{results.zone.refri}}</p>
                  <p>{{$t('icus.total')}}: {{results.total.refri}}</p>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs6 class="pa-1">
              <v-card height="150" class="text-xs-center">
                <v-card-text>
                  <h4 class="mb-2">{{$t('icus.emisiones')}} (TnCO<sub>2</sub>)</h4>
                  <p>{{$t('icus.zone')}}: {{results.zone.emisiones}}</p>
                  <p>{{$t('icus.total')}}: {{results.total.emisiones}}</p>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs6 class="pa-1">
              <v-card height="150" class="text-xs-center">
                <v-card-text>
                  <h4 class="mb-2">{{$t('icus.gasto')}} (€)</h4>
                  <p>{{$t('icus.zone')}}: {{results.zone.gasto}}</p>
                  <p>{{$t('icus.total')}}: {{results.total.gasto}}</p>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs6 class="pa-1">
              <v-card height="150" class="text-xs-center">
                <v-card-text>
                  <h4 class="mb-2">{{$t('icus.riesgo')}} (%)</h4>
                  <p>{{$t('icus.zone')}}: {{results.zone.riesgo}}</p>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

      </v-container>
    </v-navigation-drawer>
  </main>
</template>

<script>
import SourceTileWMS from 'ol/source/tilewms'
import TileLayer from 'ol/layer/tile'
import AppLegend from './Legend'

const LayerTemperaturas = new TileLayer({ opacity: 0.5 });
const LayerZonas = new TileLayer();
const LayerZonasHighlight = new TileLayer({ opacity: 0.5 });

import moment from 'moment';

export default {
  props: ['map'],
  components: {
    AppLegend,
  },
  data() {
    return {
      id: 'ICUS',
      meses: moment.localeData('es').months().map(m => m.toLowerCase()),
      isLoading: false,
      mes: {},
      stats: [{
        value: 'media',
        translate: this.$t('icus.media'),
      }, {
        value: 'alta',
        translate: this.$t('icus.alta'),
      }],
      stat: {
        value: 'media',
        translate: this.$t('icus.media'),
      },
      zones: [],
      zone: null,
      result: {},
      layerVector: null,
      dates: {
        media: {
          junio: '14-6-2017',
          julio: '24-7-2018',
          agosto: '1-8-2018',
          septiembre: '17-9-2013'
        },
        alta: {
          junio: '25-6-2017',
          julio: '14-7-2017',
          agosto: '5-8-2018',
          septiembre: '5-9-2014'
        }
      }
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.stats = [{
        value: 'media',
        translate: this.$t('icus.media'),
      }, {
        value: 'alta',
        translate: this.$t('icus.alta'),
      }];
  
      this.stat = {
        value: 'media',
        translate: this.$t('icus.media'),
      };
    });
  },

  methods: {
    getWFSLayer() {
      return fetch(`https://geoserver.greenurbandata.com/geoserver/valencia/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=valencia:isla_poligono_${this.stat.value}_${this.mes.value}&maxFeatures=1000&outputFormat=application%2Fjson`)
        .then(res => res.json());
    },

    async onChangedValues() {
      if(!this.mes.value || !this.stat.value) {
        return;
      }
      this.layerVector = await this.getWFSLayer();
      // Obtener las zonas
      this.zone = null;
      this.$nextTick(() => {
        this.zones = [...new Set(
          this.layerVector.features.map(feature => feature.properties.temper).sort((a, b) => b - a)
        )];
        this.zone = this.zones[0];
      }); 

      LayerTemperaturas.setSource(new SourceTileWMS({
        url: 'https://geoserver.greenurbandata.com/geoserver/valencia/wms',
        params: {
          layers: `isla_raster_${this.stat.value}_${this.mes.value}`,
        }
      }));

      LayerZonas.setSource(new SourceTileWMS({
        url: 'https://geoserver.greenurbandata.com/geoserver/valencia/wms',
        params: {
          layers: `isla_poligono_${this.stat.value}_${this.mes.value}`,
        }
      }));
    }
  },

  computed: {
    date() {
      console.log(this.stat, this.mes)
      if(!this.stat || !this.mes) {
        return;
      }

      return this.dates[this.stat.value][this.mes.value];
    },
    mesesLocale() {
      return moment.localeData(this.$store.getters.locale.key).months().map(m => m.toLowerCase());
    },
    layerName() {
      return `valencia:isla_raster_${this.stat.value}_${this.mes.value}`;
    },
    mesesDatos() {
      return this.vectors
        .map(({name}) => name.match(this.meses.join('|'))[0])
        .map(value => ({value, translate: this.mesesLocale[this.meses.findIndex(mes => mes === value)]}));
    },

    layers() {
      return this.$store.getters.layers;
    },

    altasRasters() {
      this.rasters.filter(layer => layer.name.includes('alta'));
    },

    altasVectors() {
      this.vectors.filter(layer => layer.name.includes('alta'));
    },

    mediasRasters() {
      this.rasters.filter(layer => layer.name.includes('media'));
    },

    mediasVectors() {
      this.vectors.filter(layer => layer.name.includes('media'));
    },

    rasters() {
      if(!this.layers) {
        return [];
      }

      const regex = new RegExp(this.meses.join('|'));
      return this.layers.LayersCS.filter(layer => layer.name.startsWith('isla'))
        .sort((a, b) => {
          const [mesA] = a.name.match(regex);
          const [mesB] = b.name.match(regex);

          const indexA = this.meses.indexOf(mesA);
          const indexB = this.meses.indexOf(mesB);

          return indexA - indexB;
        });
    },

    vectors() {
      if(!this.layers) {
        return [];
      }

      const regex = new RegExp(this.meses.join('|'));
      return this.layers.LayersDS.filter(layer => layer.name.startsWith('isla'))
        .sort((a, b) => {
          const [mesA] = a.name.match(regex);
          const [mesB] = b.name.match(regex);

          const indexA = this.meses.indexOf(mesA);
          const indexB = this.meses.indexOf(mesB);

          console.log(indexA, indexB, mesA, mesB);

          return indexA - indexB;
        });
    },

    activeControlId() {
      return this.$store.getters.activeControlId;
    },
    
    isActive() {
      return (!!this.activeControlId) && this.activeControlId.startsWith(this.id);
    },

    locale() {
      return this.$store.getters.locale;
    },
  },

  watch: {
    locale() {
      const index = this.stats.findIndex(stat => stat.value == this.stat.value);
      this.stats = this.stats.map(stat => {
        return {
          value: stat.value,
          translate: this.$t(`icus.${stat.value}`),
        }
      })

      this.$nextTick(() => this.stat = this.stats[index]);
    },
    isActive() {
      LayerTemperaturas.setMap(this.isActive ? this.map : null);
      LayerZonasHighlight.setMap(this.isActive ? this.map : null);
      LayerZonas.setMap(this.isActive ? this.map : null);
    },
    mes() {
      this.onChangedValues();
    },

    stat() {
      this.onChangedValues();
    },
    zone() {
      let superficie = 0, poblacion = 0, refri = 0, emisiones = 0, gasto = 0, riesgo = 0,
        superficieTot = 0, poblacionTot = 0, refriTot = 0, emisionesTot = 0, gastoTot = 0, riesgoTot = 0;

      this.layerVector.features.filter(feature => feature.properties.temper == this.zone)
        .forEach(feature => {
          const props = feature.properties;
          superficie += props.superficie;
          poblacion += props.poblacion;
          refri += props.refri;
          emisiones += props.emisiones;
          gasto += props.gasto;
          riesgo = props.riesgo;
        });

      this.layerVector.features
        .forEach(feature => {
          const props = feature.properties;
          superficieTot += props.superficie;
          poblacionTot += props.poblacion;
          refriTot += props.refri;
          emisionesTot += props.emisiones;
          gastoTot += props.gasto;
        });

      this.results = {
        zone: {
          superficie,
          poblacion,
          refri,
          emisiones,
          gasto,
          riesgo,
        },

        total: {
          superficie: superficieTot,
          poblacion: poblacionTot,
          refri: refriTot,
          emisiones: emisionesTot,
          gasto: gastoTot,
        }
      }


      // Sombrear zonas seleccionadas

      LayerZonasHighlight.setSource(new SourceTileWMS({
        url: 'https://geoserver.greenurbandata.com/geoserver/wms',
        params: {
          layers: `valencia:isla_poligono_${this.stat.value}_${this.mes.value}`,
          CQL_FILTER: `temper=${this.zone}`,
          STYLES: 'shared:highlight'
        }
      }));

    },
    mesesDatos() {
      console.log(this.mesesDatos);
      this.mes = this.mesesDatos[0];
    },
  },
};
</script>



// WEBPACK FOOTER //
// Icus.vue?9200c9f6